// Libraries
import Link from 'next/link';
// Components
import { ErrorCard } from '@molecules/index';
// Utils
import text from '@translations/en.json';
// Types
import { ErrorPageCardProps, ErrorType } from './ErrorPageCard.type';

/**
 * A card component that displays an error message, either for a not found page or a server error.
 *
 * @component
 * @param {ErrorPageCardProps} props - The props for the ErrorPageCard component.
 * @param {string} props.errorType - The error type to display the error message.
 * @returns {ReactElement} The ErrorPageCard component.
 */
export const ErrorPageCard = ({ errorType = ErrorType.Error }: ErrorPageCardProps) => {
  const { title, description } = text.error_card[errorType];
  const LinkablePages = [ErrorType.NotFound, ErrorType.ServerError, ErrorType.MobileAvailability];
  const button = LinkablePages.includes(errorType) ? Link : 'a';
  const hiddenButton = errorType === ErrorType.AccountCreatedSuccessfully;

  return <ErrorCard buttonAs={button} hiddenButton={hiddenButton} title={title} description={description} />;
};
